import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";

import Paths from "./paths";
import {
  EmployeeListRequest,
  EmployeeListResponse,
  Employee,
  EmployeeShortListRequest,
  EmployeeShortListResponse,
  EmployeeCreateRequest,
  EmployeeUpdateRequest,
  EmployeeAssignToAppsRequest,
  EmployeeRemoveAccessAppsRequest,
  EmployeeImportRequest,
} from "./types";

/**
 * List
 */
export const employeeListService = (params: EmployeeListRequest) =>
  RestAPIClient.call<EmployeeListResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.List,
    config: {
      requireAuthentication: true,
      params,
    },
  });

/**
 * List short
 */
export const employeeListShortService = (params: EmployeeShortListRequest) =>
  RestAPIClient.call<EmployeeShortListResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.ListShort,
    config: {
      requireAuthentication: true,
      params,
    },
  });

/**
 * Detail
 */
export const employeeDetailService = (id: number) =>
  RestAPIClient.call<Employee>({
    method: HTTPRequestMethods.GET,
    url: `${Paths.Detail}/${id}`,
    config: {
      requireAuthentication: true,
    },
  });

/**
 * Create
 */
export const employeeCreateService = (data: EmployeeCreateRequest) =>
  RestAPIClient.call<Employee>({
    method: HTTPRequestMethods.POST,
    url: `${Paths.Create}`,
    config: {
      requireAuthentication: true,
    },
    data,
  });

/**
 * Update
 */
export const employeeUpdateService = (data: EmployeeUpdateRequest) =>
  RestAPIClient.call<Employee>({
    method: HTTPRequestMethods.PUT,
    url: `${Paths.Update}/${data.id}`,
    config: {
      requireAuthentication: true,
    },
    data,
  });

/**
 * Update status
 */
export const employeeUpdateStatusService = ({
  id,
  isActive,
}: {
  id: number;
  isActive: boolean;
}) =>
  RestAPIClient.call<Employee>({
    method: HTTPRequestMethods.PUT,
    url: `${Paths.Update}/${id}/${isActive ? "active" : "inactive"}`,
    config: {
      requireAuthentication: true,
    },
  });

/**
 * Assign to apps
 */
export const employeeAssignToAppsService = (
  data: EmployeeAssignToAppsRequest
) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.POST,
    url: Paths.AssignToApps,
    config: {
      requireAuthentication: true,
    },
    data,
  });

/**
 * Remove access apps
 */
export const employeeRemoveAccessAppsService = (
  data: EmployeeRemoveAccessAppsRequest
) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.POST,
    url: Paths.RemoveAccessApps,
    config: {
      requireAuthentication: true,
    },
    data,
  });

/**
 * Import
 */
export const employeeImportService = (data: EmployeeImportRequest) =>
  RestAPIClient.call<Employee>({
    method: HTTPRequestMethods.POST,
    url: `${Paths.Import}`,
    config: {
      requireAuthentication: true,
    },
    data,
  });
